import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Link } from "react-router-dom";
import { IMG, PHONE_SHORT, PHONE_TEL } from "../../data/site";

const EASE = [0.16, 1, 0.3, 1];

const Line = ({ children, delay, className }) => (
    <span className="mask-line">
        <motion.span
            initial={{ y: "112%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1.1, delay, ease: EASE }}
            className={`block ${className || ""}`}
        >
            {children}
        </motion.span>
    </span>
);

export const Opening = () => {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start start", "end start"],
    });
    const imgY = useTransform(scrollYProgress, [0, 1], ["0%", "18%"]);
    const contentOpacity = useTransform(scrollYProgress, [0, 0.7], [1, 0]);

    return (
        <section
            id="pocetna"
            ref={ref}
            data-testid="opening-section"
            className="grain relative h-[100svh] overflow-hidden"
        >
            <motion.div style={{ y: imgY }} className="absolute inset-0">
                <motion.img
                    src={IMG.opening}
                    alt="Detalj savršeno obrađenog tamnog vozila"
                    initial={{ scale: 1.14 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 2.6, ease: EASE }}
                    className="h-full w-full object-cover"
                />
            </motion.div>
            <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0b] via-[#0a0a0b]/25 to-[#0a0a0b]/40" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#0a0a0b]/70 via-transparent to-transparent" />

            <motion.div
                style={{ opacity: contentOpacity }}
                className="absolute inset-x-0 bottom-0 px-5 pb-24 md:px-10 md:pb-16"
            >
                <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1, delay: 0.9 }}
                    className="text-[11px] font-medium uppercase tracking-[0.4em] text-bronze"
                >
                    Premium njega automobila · Ljubuški
                </motion.p>

                <h1 className="mt-5 text-[11vw] font-black uppercase leading-[0.95] tracking-tight text-bone sm:text-[8vw] lg:text-[5.2rem]">
                    <Line delay={0.25}>DETAILS</Line>
                    <Line
                        delay={0.42}
                        className="font-display font-light normal-case italic text-bronze"
                    >
                        MATTER.
                    </Line>
                </h1>

                <motion.div
                    initial={{ opacity: 0, y: 16 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.9, delay: 1.15, ease: EASE }}
                    className="mt-9 flex flex-wrap items-center gap-x-10 gap-y-5"
                >
                    <Link
                        to="/termin"
                        data-testid="opening-cta-book"
                        className="bg-bone px-9 py-4 text-[11px] font-semibold tracking-[0.26em] text-[#0a0a0b] transition-colors duration-300 hover:bg-bronze"
                    >
                        ZAKAŽI TERMIN
                    </Link>
                    <a
                        href={PHONE_TEL}
                        data-testid="opening-phone"
                        className="border-b border-bone/30 pb-1 text-sm tracking-[0.22em] text-bone/85 transition-colors duration-300 hover:border-bronze hover:text-bronze"
                    >
                        {PHONE_SHORT}
                    </a>
                </motion.div>
            </motion.div>

            <motion.span
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1.4, duration: 1 }}
                className="absolute right-6 top-24 hidden text-[10px] tracking-[0.4em] text-bone/40 md:block"
            >
                ( 01 )
            </motion.span>

            <div className="absolute bottom-0 left-1/2 hidden h-16 w-px -translate-x-1/2 overflow-hidden md:block">
                <span className="animate-scroll-cue block h-full w-px bg-bone/50" />
            </div>
        </section>
    );
};
